import React from "react";
import {
  SUPPORT_CHAT_RAMIRO_AVATAR,
  SUPPORT_CHAT_TEAM_FACE_2,
  SUPPORT_CHAT_TEAM_FACE_3,
} from "./supportChatTeamAvatars";

interface Props {
  brandLogoSrc: string;
}

/** Stack demo tipo Crisp cuando no hay admins online en modo Agente. */
export default function SupportChatDefaultTeamStack({ brandLogoSrc }: Props) {
  return (
    <>
      <span className="wsc-face wsc-face--photo" aria-hidden>
        <img src={SUPPORT_CHAT_RAMIRO_AVATAR} alt="" loading="lazy" />
      </span>
      <span className="wsc-face wsc-face--photo" aria-hidden>
        <img src={SUPPORT_CHAT_TEAM_FACE_2} alt="" loading="lazy" />
      </span>
      <span className="wsc-face wsc-face--photo" aria-hidden>
        <img src={SUPPORT_CHAT_TEAM_FACE_3} alt="" loading="lazy" />
      </span>
      <span className="wsc-face wsc-face--brand" aria-label="Wembii">
        <img src={brandLogoSrc} alt="" />
      </span>
    </>
  );
}
